import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { SITE } from "@/constants/testIds";

const HERO_IMG =
  "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1920&q=85&auto=format&fit=crop";
const HERO_VIDEO =
  "https://assets.mixkit.co/videos/4033/4033-720.mp4";

export const Hero = () => {
  return (
    <section
      id="top"
      className="relative min-h-[100svh] w-full overflow-hidden bg-grain"
    >
      {/* Cinematic background */}
      <div className="absolute inset-0">
        <video
          className="w-full h-full object-cover object-center"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster={HERO_IMG}
          aria-hidden="true"
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/85" />
        <div className="absolute inset-0 bg-grid opacity-25" />
      </div>

      {/* Top meta strip */}
      <div className="absolute top-20 md:top-24 inset-x-0 z-10">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between text-[10px] md:text-[11px] font-mono-tech uppercase tracking-[0.3em] text-neutral-400">
          <span>SYS.01 / ENERJİ · ELEKTRİK · MİMARİ</span>
          <span className="hidden md:inline">2026 · İZMİR · TR</span>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10 min-h-[100svh] flex flex-col justify-center pt-28 pb-24">
        <div className="max-w-5xl">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-8 h-px bg-[#ff5a00]" />
            <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#ff5a00]">
              MoDuLerİS — Endüstriyel Mühendislik
            </span>
          </div>

          <h1
            data-testid={SITE.heroTitle}
            className="font-display font-semibold text-white text-[44px] leading-[1.02] sm:text-6xl md:text-7xl lg:text-[88px] tracking-tight"
          >
            Geleceğin gücü,
            <br />
            <span className="italic font-light text-neutral-300">
              modüler teknolojinin
            </span>
            <br />
            estetiğiyle{" "}
            <span className="text-[#ff5a00]">buluşuyor.</span>
          </h1>

          <p className="mt-8 max-w-2xl text-neutral-300 text-base md:text-lg leading-relaxed">
            Enerji, elektrik, mimari ve mühendisliği tek bir çatı altında
            birleştiriyoruz. Endüstriyel çözümlerden sürdürülebilir enerji
            projelerine kadar — geleceği bugünden inşa ediyoruz.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              data-testid={SITE.heroCtaPrimary}
              href="#projects"
              className="btn-accent inline-flex items-center justify-center gap-2 px-7 py-4 text-[12px] uppercase tracking-[0.24em] font-semibold"
            >
              Projelerimizi İncele
              <ArrowRight size={16} />
            </a>
            <a
              data-testid={SITE.heroCtaSecondary}
              href="#contact"
              className="btn-outline inline-flex items-center justify-center gap-2 px-7 py-4 text-[12px] uppercase tracking-[0.24em] font-semibold"
            >
              Bizimle İletişime Geç
            </a>
          </div>
        </div>
      </div>

      {/* Bottom ticker */}
      <div className="absolute bottom-0 inset-x-0 z-10 border-t border-white/10 bg-black/40 backdrop-blur-md overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap py-4 font-mono-tech text-[11px] uppercase tracking-[0.3em] text-neutral-400">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-10 pr-10 shrink-0">
              <span>GES Sistemleri</span>
              <span className="text-[#ff5a00]">·</span>
              <span>Elektrik Tesisatı</span>
              <span className="text-[#ff5a00]">·</span>
              <span>Modüler Mimari</span>
              <span className="text-[#ff5a00]">·</span>
              <span>Tarihi Restorasyon</span>
              <span className="text-[#ff5a00]">·</span>
              <span>Villa Projeleri</span>
              <span className="text-[#ff5a00]">·</span>
              <span>Sürdürülebilir Enerji</span>
              <span className="text-[#ff5a00]">·</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <a
        href="#values"
        className="hidden lg:flex absolute right-8 bottom-24 z-10 flex-col items-center gap-3 text-neutral-400 hover:text-[#ff5a00] transition-colors"
      >
        <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] [writing-mode:vertical-rl] rotate-180">
          Scroll
        </span>
        <ArrowDown size={14} className="animate-bounce" />
      </a>
    </section>
  );
};

export default Hero;
